
import { useState } from 'react';
import { works } from '../data/works';
import './HSWorksGallery.css';

export default function RelatedWorks({
  category,
  title,
  initialLimit = 3,
}) {
  const [showAll, setShowAll] = useState(false);

  const related = works.filter(
    (work) => work.category === category
  );

  if (related.length === 0) return null;

  const visible = showAll
    ? related
    : related.slice(0, initialLimit);

  return (
    <section
      className="hs-works-section"
      aria-label={title || `${category}の施工実績`}
    >
      <div className="container">
        <div className="hs-works-heading">
          <span className="section-eyebrow">WORKS</span>
          <h2 className="section-h2">
            {title || `${category}の施工実績`}
          </h2>
          <p className="section-lead">
            実際の施工事例をご紹介します。
          </p>
        </div>

        <div className="hs-works-grid">
          {visible.map((work) => (
            <a
              key={work.id}
              href={work.full}
              target="_blank"
              rel="noopener noreferrer"
              className="hs-works-card"
            >
              <div className="hs-works-image-frame">
                <img
                  src={work.thumbnail}
                  alt={work.title}
                  loading="lazy"
                />
              </div>

              <div className="hs-works-card-content">
                <span className="hs-works-category">
                  {work.category}
                </span>
                <h3>{work.title}</h3>
                <span className="hs-works-zoom">
                  写真を拡大する
                </span>
              </div>
            </a>
          ))}
        </div>

        {related.length > initialLimit && (
          <div className="hs-works-more-wrap">
            <button
              type="button"
              className="hs-works-more"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll
                ? '表示を少なくする'
                : `施工実績をもっと見る（全${related.length}件）`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
